// app/javascript/controllers/quiz_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allDisciplines", "allBodySystems", "allClinicalFocuses", "allDiagnoses", "diagnosisCheckboxes", "allClinicalExcellenceTopics", "allClinicalLocations", "numberOfItems", "allCustomCourses", "customCoursesCheckboxes", "searchInput", "checkbox", "clickable", "collapsibleContent", "includePreviouslyCompletedField", "allBasicScienceDisciplines"];

  connect() {
    this.formTarget.children[0].addEventListener("change", this.handleFormChange.bind(this));
    document.addEventListener('keydown', this.closeModalOnEscape.bind(this));
    window.addEventListener('resize', this.updateActions.bind(this));
    this.updateActions();
    this.updateClasses();
  }

  disconnect() {
    window.removeEventListener('resize', this.updateActions.bind(this));
  }

  get formTarget() {
    return this.targets.find("form");
  }

  handleFormChange() {
    const form = this.formTarget.children[0];
    const formData = new FormData(form);

    const quizData = {};
    formData.forEach((value, key) => {
      if(key.split('[]').length == 1) {
        const formattedKey  = key.replace(/^quiz\[(.*)]$/, '$1');
        quizData[formattedKey] = value;
      } else {
        const formattedKey  = key.split('[]')[0].replace(/^quiz\[(.*)]$/, '$1');
        quizData[formattedKey] ||= [];
        quizData[formattedKey].push(value);
      }
    });

    const payload = { quiz: quizData };

    fetch(this.formTarget.dataset.fetchcount, { 
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then (response => response.text())
      .then(html => Turbo.renderStreamMessage(html)); 
  }

  toggleCollapse(event) {
    const card = document.getElementById(event.currentTarget.dataset.target);
    const icon = document.getElementById(event.currentTarget.dataset.icon);

    if (card.classList.contains("collapse")) {
      card.classList.remove('collapse');
      card.classList.add('expanded');
      icon.classList.add('expanded');
      if(event.currentTarget.dataset.target == "quickCardContent") {
        document.getElementById('quickStartContent').classList.remove('collapse');
      }
    } else {
      icon.classList.remove('expanded');
      card.classList.remove('expanded');
      card.classList.add('collapse');
      if(event.currentTarget.dataset.target == "quickCardContent") {
        document.getElementById('quickStartContent').classList.add('collapse');
      }
    }
  }

  toggleAllCheckboxes(target, selector) {
    const checked = target.checked;
    document.querySelectorAll(selector).forEach(checkbox => {
      checkbox.checked = checked;
    });
  }

  toggleAllDisciplines() {
    this.toggleAllCheckboxes(this.allDisciplinesTarget, "[name='quiz[clinical_disciplines][]']");
  }

  toggleAllBodySystems() {
    this.toggleAllCheckboxes(this.allBodySystemsTarget, "[name='quiz[body_systems][]']");
  }

  toggleAllClinicalFocuses() {
    this.toggleAllCheckboxes(this.allClinicalFocusesTarget, "[name='quiz[clinical_focuses][]']");
  }

  toggleAllBasicScienceDisciplines() {
    this.toggleAllCheckboxes(this.allBasicScienceDisciplinesTarget, "[name='quiz[basic_science_disciplines][]']");
  }

  toggleAllDiagnoses() {
    this.toggleAllCheckboxes(this.allDiagnosesTarget, "input[type='checkbox'][name='quiz[final_diagnoses][]']:not([style*='display: none'])");
  }

  toggleAllClinicalExcellenceTopics() {
    this.toggleAllCheckboxes(this.allClinicalExcellenceTopicsTarget, "[name='quiz[clinical_excellence][]']");
  }

  toggleAllClinicalLocations() {
    this.toggleAllCheckboxes(this.allClinicalLocationsTarget, "[name='quiz[clinical_locations][]']");
  }

  toggleAllCustomCourses() {
    this.toggleAllCheckboxes(this.allCustomCoursesTarget, "[name='quiz[custom_courses][]']");
  }

  toggleVisibility(target, event) {
    target.classList.toggle('hidden');

    const element = document.getElementById(event.currentTarget.dataset.target);
    if (target.classList.contains('hidden')) {
      element.classList.remove('expanded');
    } else {
      element.classList.add('expanded');
    }
  }

  toggleDiagnosisCheckboxes(event) {
    this.toggleVisibility(this.diagnosisCheckboxesTarget, event);
  }

  toggleCustomCoursesCheckboxes(event) {
    this.toggleVisibility(this.customCoursesCheckboxesTarget, event);
  }

  openModal() {
    const numberOfItemsField = this.numberOfItemsTarget;
    const isValid = numberOfItemsField.checkValidity();

    if (isValid) {
      $('#quizNameModal').modal('show');
      $('#quizNameModal').on('shown.bs.modal', function () {
        document.getElementById('quizName').focus();
      });
    } else {
      numberOfItemsField.reportValidity();
    }
  }

  closeModal() {
    $('#quizNameModal').modal('hide');
  }

  filterCheckboxes() {
    const searchQuery = this.searchInputTarget.value.toLowerCase();

    this.checkboxTargets.forEach(checkbox => {
      const label = checkbox.nextElementSibling;

      if (label.textContent.toLowerCase().includes(searchQuery)) {
        checkbox.style.display = "inline";
        label.style.display = "inline";
      } else {
        checkbox.style.display = "none";
        label.style.display = "none";
      }
    });
  }

  closeModalOnEscape(event) {
    if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
      this.closeModal();
    }
  }

  updateActions() {
    if (window.matchMedia("(max-width: 500px)").matches) {
      this.clickableTargets.forEach(element => element.setAttribute('data-action', 'click->quiz-form#toggleCollapse'));
    } else {
      this.clickableTargets.forEach(element => element.removeAttribute('data-action'));
    }
  }

  updateClasses() {
    if (window.innerWidth <= 500) {
      this.collapsibleContentTargets.forEach(element => element.classList.add("collapse"));
      document.getElementById('quickCardContent').classList.remove('container');
    } else {
      this.collapsibleContentTargets.forEach(element => element.classList.remove("collapse"));
      document.getElementById('quickCardContent').classList.add('container');
    }
  }

  handleEnterKeyPress(event, callback) {
    if (event.keyCode === 13) { // 13 is the key code for Enter
      event.preventDefault(); // Prevent the default action (form submission)
      callback(event);
    }
  }

  handleKeypressCheckbox(event) {
    this.handleEnterKeyPress(event, (e) => e.target.click());
  }

  handleKeypressToggleCustomCoursesCheckboxes(event) {
    this.handleEnterKeyPress(event, this.toggleCustomCoursesCheckboxes.bind(this));
  }

  handleKeypressToggleCollapse(event) {
    this.handleEnterKeyPress(event, this.toggleCollapse.bind(this));
  }

  handleKeypressToggleDiagnosisCheckboxes(event) {
    this.handleEnterKeyPress(event, this.toggleDiagnosisCheckboxes.bind(this));
  }

  handleSelection(event, selector, allTarget) {
    if (event.currentTarget.checked) {
      document.querySelectorAll(selector).forEach(checkbox => {
        checkbox.checked = false;
      });
      if (allTarget) {
        allTarget.checked = false;
      }
    }
  }

  customCourseSelected(event) {
    this.handleSelection(event, "[name='quiz[clinical_disciplines][]']", this.hasAllDisciplinesTarget ? this.allDisciplinesTarget : null);
    this.updateStudentChoiceToggleState();
  }

  clinicalDisciplineSelected(event) {
    this.handleSelection(event, "[name='quiz[custom_courses][]']", this.hasAllCustomCoursesTarget ? this.allCustomCoursesTarget : null);
  }

  togglePreviousQuestionField(event) {
    if(event.currentTarget.dataset.hide == 'true') {
      this.includePreviouslyCompletedFieldTarget.classList.add('hidden');
    } else {
      this.includePreviouslyCompletedFieldTarget.classList.remove('hidden'); 
    }
  }

  // Enable/disable the student choice toggle based on data-student-choice-case attribute
  updateStudentChoiceToggleState() {
    // Find the toggle and custom course checkboxes
    const toggle = document.getElementById('quiz_include_student_choice_cases');
    const checkboxes = document.querySelectorAll('input[name="quiz[custom_courses][]"]');

    if (!toggle || checkboxes.length === 0) return;
    let enable = false;
    checkboxes.forEach(cb => {
      if (cb.checked && cb.dataset.studentChoiceCase === 'true') {
        enable = true;
      }
    });

    toggle.disabled = !enable;
    if (!enable) toggle.checked = false;
  }
}
